import { useEffect, useState } from "react";
import Form from "react-bootstrap/Form";
import { createAppointmentApi } from "../../api-helpers/AppointmentApiHelper";
import moment from "moment-timezone";
import { formatTime } from "../PatientProfile/commonUtils";
import { getTzIdentifier } from "../../helper/momentTimezoneMapping";
import { formateDateToYYYYMMDD } from "./dateFormat";
import { createClinicalFormsApi } from "../../api-helpers/ClinicalFormsApiHelper";
import { AdditionalAttributeInfo, AssignFormRequest, FormAnswersDetails, MemberFormInfo } from "clinical-forms-experience-client";
import { formatDateToMMDDYYYY, formatTimeToHHMM } from "../../helper/dateFormatter";
import { ClinicalFormsConstants } from "../ClinicalForms/ClinicalFormsConstants";
import { stripHtmlTags } from "../../helper/TextUtils";
import { setPatientProfileReloadKey } from "../../store/slices/patientProfileReload";
import { RootState } from "../../store";
import { useDispatch, useSelector } from "react-redux";
import PhoneLink from "../../components/PhoneLink";

// eslint-disable-next-line react/prop-types
const Confirm = (props: any) => {
  const [appointmentType , setAppointmentType] = useState<string>('');
  const [appointmentMode , setAppointmentMode] = useState<string>('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const appointmentApi = createAppointmentApi();
  const clinicalformsApi = createClinicalFormsApi();
  const dispatch = useDispatch();
  const patientProfileReloadKey = useSelector((state: RootState) => state.patientProfileReloadKey.patientProfileReloadKey);
  useEffect(() => {
    getAppointmentModes();
    getAppointmentTypes();
    if(props.appointmentData.patientIds.length<1){
      props.appointmentData.patientIds=[props.selectedPatients.id];


    }
  }, []);



  const handleNextClick = async (e: any) => {
    if (props.appointmentId) {
      try {
        setIsSubmitting(true);
        await appointmentApi.appointmentControllerUpdateAppointmentById(
          props.updateAppointmentData,
          props.appointmentId
        );
        await updateProgressNotes(props.updateAppointmentData.comment ,props.appointmentId);
        props.setOpenToaster("Appointment", "success");
        props.setConfirmPage(false);
        props.setOffCanvasShow(false);
      } catch (error:any) {
        const errorMessage = error?.response?.data?.message?.message?.message;
        props.setOpenToaster(` ${errorMessage}`, "error");
      } finally {
        setIsSubmitting(false);
      }
      props.loadAppointmentDetails();
    } else {
      try {
        // props.appointmentData.time =  props.date;
        setIsSubmitting(true);
        const appointment =  await appointmentApi.appointmentControllerSaveAppointment(
          props.appointmentData
        );
        dispatch(setPatientProfileReloadKey(patientProfileReloadKey + 1))

        props.setOpenToaster("Appointment", "success");
        props.setConfirmPage(false);
        props.setOffCanvasShow(false);
        props.reloadGrid()
      } catch (error:any) {
        const errorMessage = error?.response?.data?.message?.message?.message;
        props.setOpenToaster(` ${errorMessage}`, "error");
      } finally {
        setIsSubmitting(false);
      }

    }
  }

  const back = ()=>{
    props.setConfirmPage(false);
    props.setForm(props.appointmentData);
  }

  const calculateAge = (dob: string) => {
    const birthDate = new Date(dob);
    const today = new Date();
    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDifference = today.getMonth() - birthDate.getMonth();

    // If today's month is before the birth month, or it's the same month but the current day is before the birth day, reduce the age by 1
    if (
      monthDifference < 0 ||
      (monthDifference === 0 && today.getDate() < birthDate.getDate())
    ) {
      age--;
    }

    return age;
  };

  const getAppointmentTypes = async () => {
    try {
      const category =
        await appointmentApi.appointmentControllerGetAppointmentCategory(
          "APP_ONE_ONE"
        );

        const response =
        await appointmentApi.appointmentControllerGetAppointmentTypesByCategory(
          category.data.id
        );

    const type = response.data.filter((type) => type.id === props.appointmentData.appointmentTypeId);
    setAppointmentType(type[0].name!);

    } catch (error) {}
  };

  const getAppointmentModes = async () => {
    try {
      const response =
        await appointmentApi.appointmentControllerGetAppointmentMode();

    const mode = response.data.filter((mode) => mode.id === props.appointmentData.appointmentModeId);
    setAppointmentMode(mode[0].name!);

    } catch (error) {}
  };

  const openInNewTab = (url: string) => {
    const newWindow = window.open(url, '_blank', 'noopener,noreferrer');
    if (newWindow) newWindow.opener = null;
  }

  const updateProgressNotes = async (notes:string , appointmentId:string) => {
    if(notes.length<1){
      return;
    }

    try{
      const formAnswers = (
        await clinicalformsApi.clinicalFormsControllerGetMemberAnswers(
          props.progressNotesId
        )
      ).data;

      const saveFormAnswersRequest: FormAnswersDetails = {
        formAnswers: formAnswers.formAnswers,
        additionalAnswers: formAnswers.additionalAnswers,
        comments: notes,
      };

      await clinicalformsApi.clinicalFormsControllerSaveFormResponses(
        saveFormAnswersRequest,
        props.progressNotesId!
      );

    }catch(error:any){
      console.error(error);
    }

  }

  return (
    <>
      {props.confirmType === "OneOne" && (
        <>
          <div className="p-3 border rounded-3 mt-1 bg-teal-lighter mb-3">
            <strong className="d-block fs-14">1:1 | {appointmentMode}</strong>
            <strong className="d-block fs-13">{appointmentType}</strong>
            <hr className="my-2" />
            <div className="d-flex align-items-center pe-3 border-end">
              <span className="d-block user-icon me-2">
                <img
                  src="https://cdn-icons-png.flaticon.com/512/168/168719.png"
                  alt="Martina Olivera"
                  className="img-fluid"
                />
              </span>
              <div>
                <div className="text-primary fw-semibold">
                  <a
                    href="#"
                    onClick={() => {
                      openInNewTab(
                        `/patients/${props.selectedPatients?.id}/summary`
                      );
                    }}
                  >
                    {props.selectedPatients?.name}
                  </a>
                </div>
                <div className="text-light fs-11 text-nowrap">
                  {calculateAge(props.selectedPatients?.dob)} Years
                </div>
              </div>
            </div>
            <hr className="my-2" />
            <div className="fs-11">
              {" "}
              Date -{" "}
              {formateDateToYYYYMMDD(props.date)}
            </div>
            <div className="fs-11">
              Joining time coach:{" "}
              {props.selectedCoachTimeZone && props.appointmentData?.time
                ? moment
                    .utc(props.appointmentData?.time)
                    .tz(getTzIdentifier(props.selectedCoachTimeZone))
                    .format("h:mm A")
                : "Coach Time Zone not available"}{" "}
              {props.selectedCoachTimeZone && props.selectedCoachTimeZone}
            </div>
            <div className="fs-11">
              Joining time patient:{" "}
              {props.patientTimeZone && props.appointmentData?.time
                ? moment
                    .utc(props.appointmentData?.time)
                    .tz(getTzIdentifier(props.patientTimeZone))
                    .format("h:mm A")
                : "Patient Time Zone not available"}{" "}
              {props.patientTimeZone && props.patientTimeZone}
            </div>

            {/* <div className="fs-11">Coach's Time (EST) : 9:30AM - 10:30AM (60 min)</div> */}
          </div>
          <div className="row g-2 mb-3">
            <div className="col-7">
              <label
                htmlFor="confirmEmail"
                className="form-label fs-12 fw-semibold mb-1"
              >
                Email
              </label>
              <input
                type="text"
                name="confirmEmail"
                className="form-control form-control-sm"
                id="confirmEmail"
                value={props.appointmentData?.email}
                disabled
              />
            </div>
            <div className="col-5">
              <label className="form-label fs-12 fw-semibold mb-1">
                Contact
              </label>
              <div className="form-control form-control-sm bg-body-secondary">
                <PhoneLink phone={props.appointmentData?.phone} />
              </div>
            </div>
            <div className="col-12">
              <label
                htmlFor="confirmNotes"
                className="form-label fs-12 fw-semibold mb-1"
              >
                Notes
              </label>
              <textarea
                name="careNoteQuestions"
                rows={5}
                className="form-control fs-12 overflow-auto"
                style={{ resize: "none" }}
                disabled
              >
                {stripHtmlTags(props.appointmentData?.comment)}
              </textarea>
            </div>
          </div>
        </>
      )}
      {props.confirmType === "Group" && (
        <>
          <strong className="d-block fs-18 mb-2 lh-sm">Details</strong>
          <div className="p-3 border rounded-3 bg-teal-lighter mb-3">
            <strong className="d-block fs-14">Group | Video Call</strong>
            <strong className="d-block fs-13">Tobacco cessation</strong>
            <strong className="d-block fs-12 mt-3">One time</strong>
            <div className="fs-11">Date - 06/15/24</div>
            <div className="fs-11">
              Patient's Time (PST) : 9:30AM - 10:30AM (60 min)
            </div>
            <div className="fs-11">
              Coach's Time (EST) : 9:30AM - 10:30AM (60 min)
            </div>
          </div>
          <div className="mb-3">
            <div className="form-label fs-12 fw-semibold mb-1">Coach</div>
            <div className="tag fs-12 text-light">
              <div className="tag__item is-icon">
                <span className="user-icon">
                  <span>K</span>
                </span>
                Martina Olivera
              </div>
              <div className="tag__item is-icon">
                <span className="user-icon">
                  <span>O</span>
                </span>
                Olivera
              </div>
              <div className="tag__item is-icon">
                <span className="user-icon">
                  <span>J</span>
                </span>
                John
              </div>
            </div>
          </div>
          <div className="mb-3">
            <div className="form-label fs-12 fw-semibold mb-1">Patient</div>
            <div className="d-flex">
              <div className="flex-fill tag fs-12 text-light">
                <div className="tag__item is-icon">
                  <span className="user-icon">
                    <span>
                      <img
                        src="https://cdn-icons-png.flaticon.com/512/168/168719.png"
                        alt="Martina Olivera"
                        className="img-fluid"
                      />
                    </span>
                  </span>
                  Olivera
                </div>
                <div className="tag__item is-icon">
                  <span className="user-icon">
                    <span>J</span>
                  </span>
                  John
                </div>
                <div className="tag__item is-icon">
                  <span className="user-icon">
                    <span>K</span>
                  </span>
                  Martina
                </div>
              </div>
              <div className="ms-3">
                <a
                  className="a-link a-underline text-secondary ms-3 fs-12 text-nowrap mt-2"
                  href="#"
                >
                  +5 more
                </a>
              </div>
            </div>
          </div>
          <div className="mb-3">
            <label
              htmlFor="joiningLink"
              className="form-label fs-12 fw-semibold mb-1"
            >
              Joining Link
            </label>
            <div className="position-relative">
              <input
                type="text"
                name="joiningLink"
                className="form-control form-control-sm"
                id="joiningLink"
                value="https://arjuna.com/49012900122"
                disabled
              />
              <span className="material-symbols-outlined fs-18 calendar-icon mt-05 text-light">
                content_copy
              </span>
            </div>
          </div>
          <div className="mb-3">
            <label
              htmlFor="confirmNotes"
              className="form-label fs-12 fw-semibold mb-1"
            >
              Notes (Optional)
            </label>
            <textarea
              name="careNoteQuestions"
              rows={5}
              className="form-control fs-12 overflow-auto"
              style={{ resize: "none" }}
              disabled
            >
              is simply dummy text of the printing and typesetting industry.
              Lorem Ipsum has been the industry's standard dummy text ever since
              the There are many variations of passages of Lorem Ipsum
              available, but the majority have suffered alteration in some form,
              by injected humour
            </textarea>
          </div>
        </>
      )}
      {props.confirmType === "GroupWebinar" && (
        <>
          <strong className="d-block fs-18 mb-2 lh-sm">
            Group Webinar Details
          </strong>
          <div className="p-3 border rounded-3 bg-teal-lighter mb-3">
            <strong className="d-block fs-14">Group | Video Call</strong>
            <strong className="d-block fs-13">Tobacco cessation</strong>
            <strong className="d-block fs-12 mt-3">One time</strong>
            <div className="fs-11">Date - 06/15/24</div>
            <div className="fs-11">
              Patient's Time (PST) : 9:30AM - 10:30AM (60 min)
            </div>
            <div className="fs-11">
              Coach's Time (EST) : 9:30AM - 10:30AM (60 min)
            </div>
          </div>
          <div className="mb-3">
            <div className="form-label fs-12 fw-semibold mb-1">Coach</div>
            <div className="tag fs-12 text-light">
              <div className="tag__item is-icon">
                <span className="user-icon">
                  <span>K</span>
                </span>
                Martina Olivera
              </div>
              <div className="tag__item is-icon">
                <span className="user-icon">
                  <span>O</span>
                </span>
                Olivera
              </div>
              <div className="tag__item is-icon">
                <span className="user-icon">
                  <span>J</span>
                </span>
                John
              </div>
            </div>
          </div>
          <div className="mb-3">
            <div className="form-label fs-12 fw-semibold mb-1">Patient</div>
            <div className="d-flex">
              <div className="flex-fill tag fs-12 text-light">
                <div className="tag__item is-icon">
                  <span className="user-icon">
                    <span>
                      <img
                        src="https://cdn-icons-png.flaticon.com/512/168/168719.png"
                        alt="Martina Olivera"
                        className="img-fluid"
                      />
                    </span>
                  </span>
                  Olivera
                </div>
                <div className="tag__item is-icon">
                  <span className="user-icon">
                    <span>J</span>
                  </span>
                  John
                </div>
                <div className="tag__item is-icon">
                  <span className="user-icon">
                    <span>K</span>
                  </span>
                  Martina
                </div>
              </div>
              <div className="ms-3">
                <a
                  className="a-link a-underline text-secondary ms-3 fs-12 text-nowrap mt-2"
                  href="#"
                >
                  +5 more
                </a>
              </div>
            </div>
          </div>
          <div className="mb-3">
            <label
              htmlFor="joiningLink"
              className="form-label fs-12 fw-semibold mb-1"
            >
              Joining Link
            </label>
            <div className="position-relative">
              <input
                type="text"
                name="joiningLink"
                className="form-control form-control-sm"
                id="joiningLink"
                value="https://arjuna.com/49012900122"
                disabled
              />
              <span className="material-symbols-outlined fs-18 calendar-icon mt-05 text-light">
                content_copy
              </span>
            </div>
          </div>
          <div className="mb-3">
            <label
              htmlFor="confirmNotes"
              className="form-label fs-12 fw-semibold mb-1"
            >
              Notes (Optional)
            </label>
            <textarea
              name="careNoteQuestions"
              rows={5}
              className="form-control fs-12 overflow-auto"
              style={{ resize: "none" }}
              disabled
            >
              is simply dummy text of the printing and typesetting industry.
              Lorem Ipsum has been the industry's standard dummy text ever since
              the There are many variations of passages of Lorem Ipsum
              available, but the majority have suffered alteration in some form,
              by injected humour
            </textarea>
          </div>
        </>
      )}
      <div className="offcanvas-footer w-100 border-top d-flex justify-content-between border-top">
        <div>
          <button
            className="btn btn-sm btn-outline-secondary rounded-pill px-5 fs-13"
            type="button"
            onClick={back}
          >
            Back
          </button>
        </div>
        <div>
          <button
            className="btn btn-sm btn-secondary rounded-pill px-5 fs-13"
            type="button"
            disabled={isSubmitting}
            onClick={(e) => handleNextClick(e)}
          >
            Submit
          </button>
        </div>
      </div>
    </>
  );
};
export default Confirm;
